import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
  import { useStore } from "vuex";
  import Modal from "@/components/ui/Modal.vue";
  import CheckboxInput from "@/components/ui/input/CheckboxInput.vue";
  import plural from "@/features/plural";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'ReleaseLotsModal',
  props: {
    isOpen: {
      type: Boolean,
      required: true,
    },
    listForUpdate: {
      required: true,
      type: Array,
    },
    stageId: {
      required: true,
      type: String,
    },
  },
  emits: ["close", "loading"],
  setup(__props, { expose: __expose, emit: __emit }) {
  __expose();

  const store = useStore();
  const notifyWaitlist = ref(false);
  const emits = __emit;
  const props = __props;

  const idLotsList = computed(() => {
    return props.listForUpdate.map((item) => item.id);
  });

  function close(update = false) {
    emits("close", update);
  }

  const release = () => {
    const data = {
      lotIds: idLotsList.value,
      stageId: props.stageId,
    };

    if (notifyWaitlist.value) {
      store.dispatch("subscription/notifyWaitlist", data);
    }

    close();
    emits("loading");
    store
      .dispatch("lot/setStatusAvailable", { lotIds: idLotsList.value })
      .then(() => {
        close(true);
      });
  };

const __returned__ = { store, notifyWaitlist, emits, props, idLotsList, close, release, computed, ref, get useStore() { return useStore }, Modal, CheckboxInput, get plural() { return plural } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})